var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms_modal_backdrop" }, [
    _c(
      "div",
      { staticClass: "terms_modal", staticStyle: { "text-align": "left" } },
      [
        _c("div", { staticClass: "modal-title" }, [
          _c("span"),
          _vm._v(" Privacy Policy\n            "),
          _c("img", {
            staticStyle: {
              float: "right",
              cursor: "pointer",
              "margin-top": "10px",
            },
            attrs: { src: "/img/dashboard/dev/close.svg" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ]),
        _vm._m(0),
        _c("p"),
        _vm._m(1),
        _vm._v(
          "\n            By using our website, you hereby consent to our Privacy Policy and agree to its terms.\n            "
        ),
        _c("p"),
        _c("p"),
        _vm._m(2),
        _vm._v(
          "\n            The personal information that you are asked to provide, and the reasons\n            why you are asked to provide it, will be made clear to you at the point\n             we ask you to provide your personal information. If you contact us directly,\n              we may receive additional information about you such as your name, email address,\n               phone number, the contents of the message and/or attachments you may send us, and any\n                other information you may choose to provide.\n                When you register for an Account, we may ask for your contact information, including\n                 items such as name, company name, address, email address, and telephone number.\n            "
        ),
        _c("p"),
        _c("p"),
        _vm._m(3),
        _vm._v(
          "\n                We use the information we collect in various ways, including:\n                "
        ),
        _vm._m(4),
        _c("p"),
        _c("p"),
        _vm._m(5),
        _vm._v(
          "\n                Grupa follows a standard procedure of using log files.\n                 These files log visitors when they visit websites. All\n                  hosting companies do this and a part of hosting services' analytics.\n                   The information collected by log files includes internet protocol (IP) addresses,\n                    browser type, Internet Service Provider (ISP), date and time stamp,\n                     referring/exit pages, and possibly the number of clicks. These are not\n                      linked to any information that is personally identifiable. The purpose of\n                       the information is for analyzing trends, administering the site, tracking users'\n                        movement on the website, and gathering demographic information.\n        "
        ),
        _c("p"),
        _c("p"),
        _vm._m(6),
        _vm._v(
          "\n                You may consult this list to find the Privacy Policy for each of the advertising\n                partners of Grupa. Third-party ad servers or ad networks uses technologies\n                like cookies, JavaScript, or Web Beacons that are used in their respective\n                advertisements and links that appear on Grupa, which are sent directly to users' browser. \n                They automatically receive your IP address when this occurs. \n                These technologies are used to measure the effectiveness of \n                their advertising campaigns and/or to personalize the advertising content \n                that you see on websites that you visit.\n                Note that Grupa has no access to or control over these cookies \n                that are used by third-party advertisers.\n\n        "
        ),
        _c("p"),
        _c("p"),
        _vm._m(7),
        _vm._v(
          "\n                Grupa's Privacy Policy does not apply to other advertisers or websites. \n                Thus, we are advising you to consult the respective Privacy Policies of \n                these third-party ad servers for more detailed information. It may include \n                their practices and instructions about how to opt-out of certain options. \n                You can choose to disable cookies through your individual browser options. \n                To know more detailed information about cookie management with specific web \n                browsers, it can be found at the browsers' respective websites.\n        "
        ),
        _c("p"),
        _c("p"),
        _vm._m(8),
        _vm._v(
          "\n                Under the CCPA, among other rights, California consumers have the right to:\n                Request that a business that collects a consumer's personal data disclose the \n                categories and specific pieces of personal data that a business has collected \n                about consumers.\n                Request that a business deletes any personal data about the consumer \n                that a business has collected.\n                Request that a business that sells a consumer's personal data, not sell the consumer's\n                 personal data. If you make a request, we have one month to respond to you. If you would \n                 like to exercise any of these rights, please contact us.\n        "
        ),
        _c("p"),
        _c("p"),
        _vm._m(9),
        _vm._v(
          "\n                We would like to make sure you are fully aware of all of your data \n                protection rights. Every user is entitled to the following:\n                "
        ),
        _vm._m(10),
        _vm._v(
          "\n                If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.\n\n        "
        ),
        _c("p"),
        _c("p"),
        _vm._m(11),
        _vm._v(
          "\n                Another part of our priority is adding protection for children while using the internet.\n                 We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.\n                Grupa does not knowingly collect any Personal Identifiable Information from \n                children under the age of 13. If you think that your\n                child provided this kind of information on our website, we strongly encourage you to\n                 contact us immediately and we will do our best efforts to promptly remove such\n                  information from our records.\n        "
        ),
        _c("p"),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n            At Grupa, accessible from\n            "),
      _c("a", { attrs: { href: "http://grupa.io" } }, [
        _vm._v("http://grupa.io"),
      ]),
      _vm._v(
        " one of our main priorities\n             is the privacy of our visitors. This Privacy Policy document contains types\n              of information that are collected and recorded by Grupa and how we use it.\n               If you have additional questions or require more information about our Privacy \n               Policy, do not hesitate to contact us.\n            This Privacy Policy applies only to our online\n             activities and is valid for visitors to our website \n             with regards to the information that they shared and/or\n              collect in Grupa. This policy is not applicable to any \n              information collected offline or via channels other than this website. \n        "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("Consent")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("Information we collect")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("How we use your information")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("Provide, operate, and maintain our website")]),
      _c("li", [_vm._v("Improve, personalize, and expand our website")]),
      _c("li", [_vm._v("Understand and analyze how you use our website")]),
      _c("li", [
        _vm._v("Develop new products, services, features, and functionality"),
      ]),
      _c("li", [
        _vm._v(
          "Communicate with you, either directly or through one of our partners, including for customer service,\n                         to provide you with updates and other information relating to the website,\n                          and for marketing and promotional purposes"
        ),
      ]),
      _c("li", [_vm._v("Send you emails")]),
      _c("li", [_vm._v("Find and prevent fraud")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("Log Files")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("Advertising Partners Privacy Policies")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("Third-Party Privacy Policies")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [
        _vm._v("CCPA Privacy Rights (Do Not Sell My Personal Information)"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("GDPR Data Protection Rights")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "dashed" }, [
      _c("li", [
        _c("span", { staticClass: "list-padding" }, [
          _vm._v(
            "\n                        The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service."
          ),
        ]),
      ]),
      _c("li", [
        _c("span", { staticClass: "list-padding" }, [
          _vm._v(
            "\n                        The right to rectification – You have the right to request that we correct any information you believe is inaccurate. \n                        You also have the right to request that we complete the information you believe is incomplete."
          ),
        ]),
      ]),
      _c("li", [
        _c("span", { staticClass: "list-padding" }, [
          _vm._v(
            "The right to erasure – You have the right to request that we erase your personal data, under certain conditions."
          ),
        ]),
      ]),
      _c("li", [
        _c("span", { staticClass: "list-padding" }, [
          _vm._v(
            "The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions."
          ),
        ]),
      ]),
      _c("li", [
        _c("span", { staticClass: "list-padding" }, [
          _vm._v(
            "The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions."
          ),
        ]),
      ]),
      _c("li", [
        _c("span", { staticClass: "list-padding" }, [
          _vm._v(
            "The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headeline" }, [
      _c("b", [_vm._v("Children's Information")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }